import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {Restaurant} from "../../shared/model/restaurant";

@Component({
  selector: 'app-tables-raitings',
  templateUrl: './tables-raitings.component.html',
  styleUrls: ['./tables-raitings.component.css']
})
export class TablesRaitingsComponent implements OnInit {

  private restaurantId:String;
  restaurantName :string;
  private restaurant:Restaurant;

  constructor(
    private route:ActivatedRoute
  ) {

    route.data
      .subscribe( ( data : {restaurant:Restaurant  }) =>
        {
          this.restaurant = data.restaurant;
        }

      )
  }

  ngOnInit() {


    this.restaurantId =  this.restaurant.$key;
    this.restaurantName = this.restaurant.restaurant;
    console.log(this.restaurantId);

  }

}



// WEBPACK FOOTER //
// ./src/app/table/tables-raitings/tables-raitings.component.ts